<div class="scroll_container">
  <div class="project-header">
    <div class="vertical-center header-content">

      <a matTooltip="{{ variables.goBack}}" matTooltipPosition="below" aria-label="{{ variables.goBack}}"
        (click)="goBack()">
        <mat-icon class="header-icon-img">arrow_circle_left</mat-icon>
      </a>

      <div class="header-text">
        <h4>{{variables.project}} {{project.name ? project.name : ''}}</h4>
        <p>{{project.wbscode}}</p>
      </div>
    </div>

    <div class="main-phase-stepper">
      <div [class.phase-active]="selectedSectionIndex === 0" class="phase-step" (click)="onSectionChange(0)">
        <div class="phase-number">
          <mat-icon class="icon-style">assignment</mat-icon>
        </div>
        <span class="phase-label">{{variables.estimates}}</span>
      </div>
      <div class="phase-divider"></div>
      <div [class.phase-active]="selectedSectionIndex === 1" class="phase-step" (click)="onSectionChange(1)">
        <div class="phase-number">
          <mat-icon class="icon-style">group</mat-icon>
        </div>
        <span class="phase-label">{{variables.users}}</span>
      </div>
    </div>
  </div>

  <div class="financial-summary">
    <div>
      <mat-card class="summary-card">
        <mat-card-header>
          <div class="summary-card-content">
            <mat-card-title>{{ financialSummary.baseline | currency:'EUR':'symbol':'1.2-2' }}</mat-card-title>
            <mat-card-subtitle>{{ variables.baseline }}</mat-card-subtitle>
          </div>
        </mat-card-header>
      </mat-card>
    </div>

    <div>
      <mat-card class="summary-card">
        <mat-card-header>
          <div class="summary-card-content">
            <mat-card-title>{{ financialSummary.initialCost | currency:'EUR':'symbol':'1.2-2' }}</mat-card-title>
            <mat-card-subtitle>{{ variables.initialCost }}</mat-card-subtitle>
          </div>
        </mat-card-header>
        <span *hasPermission="Permission.PROJECT_EDIT_INITIAL_COST" (click)="openEditInitialCostDialog()" class="edit-initial-cost-btn">
          <img src="assets/svg/EditWhite.svg" alt="Edit Icon" width="16px">
        </span>
      </mat-card>
    </div>

    <div>
      <mat-card class="summary-card">
        <mat-card-header>
          <div class="summary-card-content">
            <mat-card-title>{{ financialSummary.upgrades | currency:'EUR':'symbol':'1.2-2' }}</mat-card-title>
            <mat-card-subtitle>{{ variables.upgrades }}</mat-card-subtitle>
          </div>
        </mat-card-header>
      </mat-card>
    </div>

    <div>
      <mat-card class="summary-card">
        <mat-card-header>
          <div class="summary-card-content">
            <mat-card-title>{{ financialSummary.maintenance | currency:'EUR':'symbol':'1.2-2' }}</mat-card-title>
            <mat-card-subtitle>{{ variables.maintenance }}</mat-card-subtitle>
          </div>
        </mat-card-header>
      </mat-card>
    </div>
  </div>

  <div class="estimates">
    @if (isLoading && !errorDetected) {
    <app-loader class="centerLoader pt-5"></app-loader>
    }

    @if (errorDetected) {
    <app-error-message [errorMsg]="errorText"></app-error-message>
    }

    @if (!openManageTable && notAssociatedEstimates.data.length > 0 && !isLoading && !errorDetected) {
    <div class="mat-elevation-z0">
      <mat-card class="table-card table-container">
        <div class="top-table">
          @if (variables && variables.lastProjects) {
          <h5>{{variables.listEstimatesWithoutAssociation}}</h5>
          }
          @if (variables && variables.groupEstimates) {
          <div *hasPermission="Permission.ESTIMATE_WRITE" class="top-table-buttons">
            @if (!(selection.isEmpty())) {
            <app-button typeBtn="primary" (click)="associateEstimates()" class="app-button" iconPosition="left"
              icon="create_new_folder" [textColor]="colorWhite" color="var(--primary-color)"
              message="{{variables.groupEstimates}}"></app-button>
            }
          </div>
          }
        </div>
        @if (notAssociatedEstimates.data.length > 0) {
        <div>
          <table mat-table matSort [dataSource]="notAssociatedEstimates">
            <!-- Checkbox Column -->
            <ng-container *hasPermission="Permission.ESTIMATE_WRITE" matColumnDef="select">
              <th mat-header-cell style="flex-basis: 5%;" *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()"></mat-checkbox>
              </th>
              <td mat-cell style="flex-basis: 5%;" *matCellDef="let row">
                <span [matTooltip]="associationDisabledMessage(row.state ,  row.estimateMode)">
                  <mat-checkbox (click)="hasDifferentMethodology($event)"
                    (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
                    [disabled]="associationDisabledCodition(row.state ,  row.estimateMode)">
                  </mat-checkbox>
                </span>
              </td>
            </ng-container>
            <!-- ID Column -->
            <ng-container matColumnDef="ID">
              <th mat-header-cell style="flex-basis: 10%;" *matHeaderCellDef>
                <strong>
                  Id
                </strong>
              </th>
              <td mat-cell style="flex-basis: 10%;" *matCellDef="let element">
                {{element.idEstimate}} </td>
            </ng-container>
            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell style="flex-basis: 15%;" *matHeaderCellDef>
                <strong>
                  {{variables.name}}
                </strong>
              </th>
              <td class="td-name" mat-cell style="flex-basis: 15%;" *matCellDef="let element">
                <div> {{element.name}} </div>
              </td>
            </ng-container>

            <!-- Catalog Column -->
            <ng-container matColumnDef="catalog">
              <th mat-header-cell style="flex-basis: 10%;" *matHeaderCellDef>
                <strong>
                  {{variables.catalog}}
                </strong>
              </th>
              <td class="td-name" mat-cell style="flex-basis: 10%;" class="vertical-center" *matCellDef="let row">
                <div>{{row.catalog}}</div>
              </td>
            </ng-container>

            <!-- Date i Column -->
            <ng-container matColumnDef="data_i">
              <th mat-header-cell style="flex-basis: 10%;" class="text-center" *matHeaderCellDef>
                <strong>
                  {{variables.creationDate}}
                </strong>
              </th>
              <td mat-cell style="flex-basis: 10%;" class="date-center" *matCellDef="let element">
                {{element.createdDate}} </td>
            </ng-container>

            <!-- Date f Column -->
            <ng-container matColumnDef="data_f">
              <th mat-header-cell style="flex-basis: 15%;" class="text-center" *matHeaderCellDef>
                <strong>
                  {{variables.changeDate}}
                </strong>
              </th>
              <td mat-cell style="flex-basis: 15%;" class="date-center" *matCellDef="let element">
                {{element.lastModifiedDate}} </td>
            </ng-container>

            <!-- Methodology Column -->
            <ng-container matColumnDef="method">
              <th mat-header-cell style="flex-basis: 15%;" *matHeaderCellDef>
                <strong>
                  {{variables.metodology}}
                </strong>
              </th>
              <td mat-cell style="flex-basis: 15%;" *matCellDef="let element">
                <div>
                  @if (element.estimateMode !== 'other') {
                  <span>Agile - </span>
                  }{{element.estimateMode}}
                </div>
              </td>
            </ng-container>

            <!-- State Column -->
            <ng-container class="table-state" matColumnDef="state">
              <th mat-header-cell style="flex-basis: 11%;" *matHeaderCellDef mat-sort-header>{{variables.state}}</th>
              <td mat-cell style="flex-basis: 11%;" class="vertical-center" *matCellDef="let row">
                <span class="state-background" [ngClass]="{
                  'green-class': row.state === EstimationState.CERTIFIED || row.state === EstimationState.APPROVED,
                  'yellow-class': row.state === EstimationState.INCOMPLETE ,
                  'red-class': row.state === EstimationState.TO_FIX ,
                  'dark-green-class': row.state === EstimationState.CLOSED,
                  'dark-red-class': row.state === EstimationState.REJECTED,
                  'blue-class': row.state === EstimationState.COMPLETE
                }">
                  {{ getStateText(row.state) }}
                </span>
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell style="flex-basis: 10%;" class="vertical-center horizontal-center" *matHeaderCellDef>
                <strong>
                  {{variables.actions}}
                </strong>
              </th>
              <td mat-cell style="flex-basis: 10%;" class="vertical-center horizontal-center-btn" *matCellDef="let row">

                <span *hasPermission="Permission.ESTIMATE_WRITE" (click)="editEstimate(row)" class="action_buttons-item"
                  [matTooltip]="canEditEstimateMessage(row)" [class.disabled]="!canEditEstimate(row)">
                  <mat-icon class="action-btns-styles" width="20px">edit</mat-icon>
                </span>

                <span (click)="checkEstimate(row)" class="action_buttons-item"
                  [matTooltip]="canCheckEstimateMessage(row)" [class.disabled]="!canCheckEstimate(row)">
                  <mat-icon class="action-btns-styles" width="20px">remove_red_eye</mat-icon>
                </span>

                <span *hasPermission="Permission.ESTIMATE_WRITE" (click)="deleteEstimate(row)"
                  class="action_buttons-item" [matTooltip]="canDeleteEstimateMessage(row)"
                  [class.disabled]="!canDeleteEstimate(row)">
                  <mat-icon class="action-btns-styles" width="20px">delete</mat-icon>
                </span>


              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
        }
        <mat-paginator #paginator1 [length]="notAssociatedEstimates.data.length" [pageIndex]="0" [pageSize]="5"
          [hidePageSize]="true" aria-label="Select page">
        </mat-paginator>
      </mat-card>
    </div>
    }
    @if (!(selection.isEmpty())) {
    <br>
    }

    @if (!openManageTable && !isLoading && !errorDetected) {
    <div class="folders">
      @for (folder of associatedFolders; track folder) {
      <div class="folder-item">

        <span class="folder-span" for="label">
          <mat-icon>folder</mat-icon>
          <strong>{{folder.name}}</strong>
          <span>
            <button mat-icon-button class="custom-button" (click)="toggleDivVisibility(folder.name)">
              <mat-icon>expand_more</mat-icon>
            </button>
          </span>
        </span>

        <mat-card class="table-card table-container">
          @if (folder.isVisible) {
          <div @slideToggle class="table-wrapper table-card">
            <table mat-table matSort [dataSource]="folder.estimates" (matSortChange)="sortData($event)"
              class="folders-table">
              <!-- ID Column -->
              <ng-container matColumnDef="ID">
                <th mat-header-cell style="flex-basis: 15%;" *matHeaderCellDef>
                  <strong>
                    Id
                  </strong>
                </th>
                <td mat-cell style="flex-basis: 15%;" *matCellDef="let element">
                  {{element.idEstimate}} </td>
              </ng-container>
              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell style="flex-basis: 20%;" *matHeaderCellDef>
                  <strong>
                    {{variables.name}}
                  </strong>
                </th>
                <td mat-cell style="flex-basis: 20%;" *matCellDef="let element">
                  {{element.name}} </td>
              </ng-container>
              <!-- Methodology Column -->
              <ng-container matColumnDef="method">
                <th mat-header-cell style="flex-basis: 20%;" *matHeaderCellDef>
                  <strong>
                    {{variables.metodology}}
                  </strong>
                </th>
                <td mat-cell style="flex-basis: 20%;" *matCellDef="let element">
                  <div>
                    @if (element.estimateMode !== 'other') {
                    <span>Agile - </span>
                    }{{element.estimateMode}}
                  </div>
                </td>
              </ng-container>
              <!-- Date i Column -->
              <ng-container matColumnDef="data_i">
                <th mat-header-cell style="flex-basis: 15%;" class="date-center" *matHeaderCellDef>
                  <strong>
                    {{variables.creationDate}}
                  </strong>
                </th>
                <td mat-cell style="flex-basis: 15%;" class="date-center" *matCellDef="let element">
                  {{element.createdDate}} </td>
              </ng-container>
              <!-- Date f Column -->
              <ng-container matColumnDef="data_f">
                <th mat-header-cell style="flex-basis: 15%;" class="date-center" *matHeaderCellDef>
                  <strong>
                    {{variables.changeDate}}
                  </strong>
                </th>
                <td mat-cell style="flex-basis: 15%;" class="date-center" *matCellDef="let element">
                  {{element.lastModifiedDate}} </td>
              </ng-container>
              <!-- Last Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell style="flex-basis: 15%;" class="horizontal-center" *matHeaderCellDef>
                  <app-button typeBtn="primary" message="{{variables.combinateEstimates}}"
                    (click)="!hasIncompleteEstimate(folder.estimates) && combinatedResult(folder.estimates, folder.name)"
                    [disabled]="hasIncompleteEstimate(folder.estimates)"
                    [matTooltip]="hasIncompleteEstimate(folder.estimates) ? variables.tooltipCombinated : ''">
                  </app-button>
                </th>
                <td style="flex-basis: 15%;" mat-cell class="horizontal-center" *matCellDef="let element">
                  <div class="action_buttons ">
                    <span *hasPermission="Permission.ESTIMATE_WRITE" class="action_buttons-item"
                      (click)="removeEstimate(element)">
                      <mat-icon svgIcon="De-attachmentWhite" class="action-btns-styles"
                        style="width:20px; height:20px;"></mat-icon>
                    </span>

                    <span *hasPermission="Permission.PROJECT_READ" (click)="checkEstimate(element)"
                      class="action_buttons-item" [matTooltip]="canCheckEstimateMessage(element)"
                      [class.disabled]="!canCheckEstimate(element)">
                      <mat-icon class="action-btns-styles" width="20px">remove_red_eye</mat-icon>
                    </span>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsAssociated"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsAssociated;"></tr>
            </table>
          </div>
          }
        </mat-card>
      </div>
      }
      <br>
      <div style="float: right;">
        @if (showSave) {
        <app-button typeBtn="primary" (click)="saveEstimates()" [textColor]="colorWhite"
          message="{{variables.save1}}"></app-button>
        }
      </div>
      <div style="margin-top: 80px;">
        @if (notAssociatedEstimates.data && this.associatedFolders && notAssociatedEstimates.data.length == 0 &&
        this.associatedFolders.length == 0) {
        <h5 style="text-align: center;">
          {{variables.hasEstimates}}</h5>
        }
      </div>
    </div>
    }

    <!-- manage users table -->
    @if (openManageTable && !isLoading && !errorDetected ) {
    <div>
      <div class="mb-5">

        <mat-card class="table-card table-container">
          @if (project.users.length > 0;) {
          <div class="mat-elevation-z0 table-card">
            <table matSort mat-table [dataSource]="dataSourceUsers" class="users-table">
              <!-- Name -->
              <ng-container matColumnDef="name">
                <th mat-header-cell style="flex-basis: 35%;" *matHeaderCellDef>
                  <strong>{{variables.name}}</strong>
                </th>
                <td mat-cell style="flex-basis: 35%;" *matCellDef="let element">
                  {{element.name}}
                </td>
              </ng-container>
              <!-- DAS ID -->
              <ng-container matColumnDef="mail">
                <th mat-header-cell style="flex-basis: 45%;" *matHeaderCellDef><strong>Email</strong> </th>
                <td mat-cell style="flex-basis: 45%;" *matCellDef="let element">{{element.email}}</td>
              </ng-container>
              <!-- ACTIONS -->
              <ng-container matColumnDef="actions">
                @if ( ((authService.isAdministrator() | async) && isProjectOwner()) || (authService.isSuperAdmin() |
                async) ) {
                <th mat-header-cell style="flex-basis: 10%;" class="horizontal-center" *matHeaderCellDef>
                  <strong>{{variables.actions}}</strong>
                </th>
                <td mat-cell style="flex-basis: 10%;" class="horizontal-center" *matCellDef="let element">
                  <div class="action_buttons">
                    <span class="action_buttons-item" (click)="removeUser(element.name, element.email)">
                      <mat-icon class="action-btns-styles" width="20px">delete</mat-icon>
                    </span>
                  </div>
                </td>
                }
                @else
                {
                <th mat-header-cell style="flex-basis: 10%;" class="horizontal-center" *matHeaderCellDef>
                </th>
                <td mat-cell style="flex-basis: 10%;" class="horizontal-center" *matCellDef="let element">
                </td>
                }
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns1"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns1;"></mat-row>
            </table>
            <mat-paginator class="user-paginator" id="paginator2" #paginator2 [length]="dataSourceUsers.data.length"
              [pageIndex]="0" [pageSize]="5" [hidePageSize]="true" aria-label="Select page">
            </mat-paginator>
          </div>
          }
        </mat-card>
        @if (!(project.users.length > 0)) {
        <div style="margin-top: 80px; margin-bottom: 40px;">
          @if (!showSave) {
          <h5 style="text-align: center;">{{variables.hasProjectUsers}}</h5>
          }
        </div>
        }
        <div class="buttons-add-save users-actions">
          <app-button *hasPermission="Permission.PROJECT_MANAGE" typeBtn="primary" (click)="openDialogAddUser()"
            [textColor]="colorWhite" message="{{variables.addUserToProject}}"></app-button>
          <!--div class="buttons-add-save_save">
                  <app-button typeBtn="primary"  (click)="saveUsers()" [textColor]="colorWhite"  message="{{variables.save1}}"></app-button>
                </div-->
        </div>
      </div>
    </div>
    }
  </div>

  @if (!openManageTable) {
  <div class="create-estimate-action" *hasPermission="Permission.ESTIMATE_WRITE">
    <app-button typeBtn="primary" (click)="goTo('estimativa', project.name)"
      message="{{variables.createNewEstimate}}"></app-button>
  </div>
  }
</div>